import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// 🟦 Get All Addresses
export const getAddresses = createAsyncThunk(
  "addresses/getAddresses",
  async (_, { rejectWithValue }) => {
    try {
      const tokenData = JSON.parse(localStorage.getItem("authUser"));
      const token = tokenData?.data?.token?.replace("Bearer ", "");

      const response = await axios.get(`${API_URL}/address`, {
        headers: { Authorization: token },
      });

      return response.data; // expected: { data: [...] }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to load address",
      );
    }
  },
);

// 🟦 Add a new address
export const addAddress = createAsyncThunk(
  "addresses/addAddress",
  async ({ addressData }, { rejectWithValue }) => {
    try {
      // console.log("Adding address:", addressData);
      // console.log("User ID:", userId);
      const tokenData = JSON.parse(localStorage.getItem("authUser"));
      const token = tokenData?.data?.token?.replace("Bearer ", "");

      const response = await axios.post(`${API_URL}/address`, addressData, {
        headers: { Authorization: token },
      });

      return response.data; // expected: { data: {...newAddress} }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to add address",
      );
    }
  },
);

// 🟦 Update Existing Address
export const updateAddress = createAsyncThunk(
  "addresses/updateAddress",
  async ({ addressId, addressData }, { rejectWithValue }) => {
    try {
      const tokenData = JSON.parse(localStorage.getItem("authUser"));
      const token = tokenData?.data?.token?.replace("Bearer ", "");

      const response = await axios.put(
        `${API_URL}/address/${addressId}`,
        addressData,
        {
          headers: { Authorization: token },
        },
      );

      return response.data; // updated object
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to update address",
      );
    }
  },
);

// 🟦 Delete Address
export const deleteAddress = createAsyncThunk(
  "addresses/deleteAddress",
  async ({ addressId }, { rejectWithValue }) => {
    try {
      const tokenData = JSON.parse(localStorage.getItem("authUser"));
      const token = tokenData?.data?.token?.replace("Bearer ", "");

      await axios.delete(`${API_URL}/address/${addressId}`, {
        headers: { Authorization: token },
      });

      return addressId; // return id to remove from redux
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete address",
      );
    }
  },
);
